const state = {
  loading: false,
  snackbar: {},
  layout: 'survey'
};

const getters = {
  layout (state) {
    return state.layout;
  },
  snackbar (state) {
    return state.snackbar;
  },
  loading (state) {
    return state.loading;
  }
};

const mutations = {
  setLayout (state, payload) {
    state.layout = payload;
  },
  setSnackbar (state, payload) {
    state.snackbar = payload;
  },
  setLoading (state, payload) {
    state.loading = payload;
  },
  isLoading (state, payload) {
    state.loading = !state.loading;
  }
};

const actions = {
  setLayout (context, payload) {
    context.commit('setLayout', payload);
  },
  setSnackbar (context, payload) {
    context.commit('setSnackbar', payload);
  },
  setLoading (context, payload) {
    context.commit('setLoading', payload);
  },
  callIsLoading (context) {
    context.commit('isLoading');
  }
};

export default {
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js